document.addEventListener('DOMContentLoaded', () => {
    // =========================================================================
    // MIKILVÆG ÖRYGGISVIÐVÖRUN
    // =========================================================================
    // Þessir API lyklar eru sýnilegir í kóða vefsíðunnar. Til að tryggja 
    // öryggi þarft þú að gera eftirfarandi:
    // 1. Fara í Google Cloud Console -> APIs & Services -> Credentials.
    // 2. Velja þennan API lykil.
    // 3. Undir "Application restrictions", velja "Websites" og bæta við
    //    vefslóðunum þínum (t.d. https://thin-verslun.myshopify.com og 
    //    https://thitt-len.is/*).
    // 4. Íhuga að virkja "Firebase App Check" fyrir enn frekara öryggi.
    // =========================================================================
    const firebaseConfig = {
        apiKey: "AIzaSyDJngLtHVQ-1Q_muZPQBsYczWX0e6LNV8w",
        authDomain: "bestathu-80012.firebaseapp.com",
        projectId: "bestathu-80012",
        storageBucket: "bestathu-80012.appspot.com",
        messagingSenderId: "944448419154",
        appId: "1:944448419154:web:becfe8ffa4599c873a768b"
    };
    
    firebase.initializeApp(firebaseConfig);
    const auth = firebase.auth();
    const db = firebase.firestore();

    AOS.init({ duration: 1000, once: true });
    
    // Sækjum öll element
    const authContainer = document.getElementById('auth-container');
    const appContainer = document.getElementById('app-container');
    const loginForm = document.getElementById('login-form');
    const registerForm = document.getElementById('register-form');
    const logoutButton = document.getElementById('logout-button');
    const pendingLogoutButton = document.getElementById('pending-logout-button');
    const registerContainer = document.getElementById('register-container');
    const showRegisterLink = document.getElementById('show-register-link');
    const showLoginLink = document.getElementById('show-login-link');
    const memberNameSpan = document.getElementById('member-name');
    const registerSuccessMessage = document.getElementById('register-success-message');
    const memberContent = document.getElementById('member-content');
    const pendingApprovalContainer = document.getElementById('pending-approval-container');
    const forgotPasswordLink = document.getElementById('forgot-password-link');
    const loadingSpinner = document.getElementById('loading-spinner');
    const loginErrorMessage = document.getElementById('login-error-message');
    const registerErrorMessage = document.getElementById('register-error-message');


    let currentUser = null;
    let userProfile = null;
    const defaultProfile = { displayName: "", email: "", completedExercises: [], streak: 0, measurements: [], personalRecords: {}, isMember: false };
    const motivationalQuotes = ["Þú ert sterkari en þú heldur.", "Eitt skref í einu kemur þér á leiðarenda.", "Árangur er summa af litlum sigrum, dag eftir dag.", "Trúðu á þig og allt sem þú ert.", "Besti tíminn til að byrja var í gær. Næstbesti tíminn er núna."];

    auth.onAuthStateChanged(user => {
        if (loadingSpinner) loadingSpinner.style.display = 'none';

        if (user) {
            currentUser = user;
            if (authContainer) authContainer.style.display = 'none';
            if (appContainer) appContainer.style.display = 'block';

            loadProgressData(user.uid).then(() => {
                if (userProfile && userProfile.isMember === true) {
                    if (pendingApprovalContainer) pendingApprovalContainer.style.display = 'none';
                    if (memberContent) memberContent.style.display = 'block';
                    renderDashboard();
                } else {
                    if (memberContent) memberContent.style.display = 'none';
                    if (pendingApprovalContainer) pendingApprovalContainer.style.display = 'block';
                }
            });
        } else {
            currentUser = null;
            userProfile = null;
            if (appContainer) appContainer.style.display = 'none';
            if (authContainer) authContainer.style.display = 'block';
        }
    });
    
    function getIcelandicErrorMessage(errorCode) {
        const messages = {
            'auth/wrong-password': 'Rangt lykilorð. Vinsamlegast reyndu aftur.',
            'auth/user-not-found': 'Enginn notandi fannst með þessu netfangi.',
            'auth/invalid-email': 'Þetta er ekki gilt netfang.',
            'auth/email-already-in-use': 'Þetta netfang er þegar í notkun.',
            'auth/weak-password': 'Lykilorðið verður að vera að minnsta kosti 6 stafir á lengd.',
        };
        return messages[errorCode] || 'Óþekkt villa kom upp. Vinsamlegast hafðu samband.';
    }

    if (registerForm) {
        registerForm.addEventListener('submit', e => {
            e.preventDefault();
            if (registerErrorMessage) registerErrorMessage.style.display = 'none'; 

            const name = document.getElementById('register-name').value;
            const email = document.getElementById('register-email').value;
            const password = document.getElementById('register-password').value;
            if (!name) { return alert('Vinsamlegast fylltu út nafn.'); }
            let createdUser;
            auth.createUserWithEmailAndPassword(email, password)
                .then(cred => {
                    createdUser = cred.user;
                    return createdUser.updateProfile({ displayName: name });
                })
                .then(() => {
                    const newUserProfile = { ...defaultProfile, displayName: name, email: email };
                    return db.collection('userProgress').doc(createdUser.uid).set(newUserProfile);
                })
                .then(() => {
                    if (registerForm) registerForm.style.display = 'none';
                    if (registerSuccessMessage) registerSuccessMessage.style.display = 'block';
                })
                .catch(err => {
                    if (registerErrorMessage) {
                       registerErrorMessage.textContent = getIcelandicErrorMessage(err.code);
                       registerErrorMessage.style.display = 'block';
                    }
                });
        });
    }

    if (loginForm) {
        loginForm.addEventListener('submit', e => {
            e.preventDefault();
            if(loginErrorMessage) loginErrorMessage.style.display = 'none';

            const email = document.getElementById('login-email').value;
            const password = document.getElementById('login-password').value;
            const rememberMe = document.getElementById('remember-me').checked;
            const persistence = rememberMe ? firebase.auth.Auth.Persistence.LOCAL : firebase.auth.Auth.Persistence.SESSION;

            auth.setPersistence(persistence)
                .then(() => auth.signInWithEmailAndPassword(email, password))
                .catch(error => {
                    if (loginErrorMessage) {
                        loginErrorMessage.textContent = getIcelandicErrorMessage(error.code);
                        loginErrorMessage.style.display = 'block';
                    }
                });
        });
    }
    
    if (forgotPasswordLink) {
        forgotPasswordLink.addEventListener('click', e => {
            e.preventDefault();
            const email = prompt('Vinsamlegast sláðu inn netfangið þitt til að endurstilla lykilorðið:');
            if (email) {
                auth.sendPasswordResetEmail(email)
                    .then(() => alert('Leiðbeiningar hafa verið sendar á netfangið þitt.'))
                    .catch(error => alert('Villa kom upp: ' + error.message));
            }
        });
    }

    if (logoutButton) logoutButton.addEventListener('click', () => auth.signOut());
    if (pendingLogoutButton) pendingLogoutButton.addEventListener('click', () => auth.signOut());
    if (showRegisterLink) showRegisterLink.addEventListener('click', e => { e.preventDefault(); if (registerContainer) registerContainer.classList.add('is-visible'); });
    if (showLoginLink) showLoginLink.addEventListener('click', e => { e.preventDefault(); if (registerContainer) registerContainer.classList.remove('is-visible'); });

    async function loadProgressData(userId) {
        const docRef = db.collection('userProgress').doc(userId);
        try {
            const doc = await docRef.get();
            if (doc.exists) {
                userProfile = { ...defaultProfile, ...doc.data() };
            } else {
                userProfile = { ...defaultProfile, displayName: currentUser.displayName, email: currentUser.email };
                await db.collection('userProgress').doc(userId).set(userProfile);
            }
        } catch (error) {
            console.error("Villa við að sækja gögn:", error);
            userProfile = { ...defaultProfile };
        }
    }
    
    function getGreeting() {
        const hour = new Date().getHours();
        if (hour < 12) return "Góðan daginn";
        if (hour < 18) return "Góðan dag";
        return "Gott kvöld";
    }

    function animateValue(obj, start, end, duration) {
        if (!obj) return;
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                obj.innerHTML = end;
            }
        };
        window.requestAnimationFrame(step);
    }
    
    function renderDashboard() {
        if (!userProfile) return;
        
        calculateCurrentStreak(); 

        const greetingText = document.getElementById('greeting-text');
        if (greetingText) {
            greetingText.textContent = getGreeting();
        }

        const userName = currentUser.displayName || userProfile.displayName || 'meðlimur';
        if (memberNameSpan) {
            memberNameSpan.textContent = userName;
        }
        
        const quoteElement = document.getElementById('daily-quote');
        if (quoteElement) {
            const randomIndex = Math.floor(Math.random() * motivationalQuotes.length);
            quoteElement.textContent = `"${motivationalQuotes[randomIndex]}"`;
        }
    }
    
    function calculateCurrentStreak() {
        if (!userProfile || !userProfile.completedExercises || userProfile.completedExercises.length === 0) {
            if (userProfile) userProfile.streak = 0;
            return;
        }

        const uniqueDates = [...new Set(userProfile.completedExercises.map(ex => ex.date.split('T')[0]))]
            .map(dateStr => new Date(dateStr))
            .sort((a, b) => b - a); 

        if (uniqueDates.length === 0) {
            userProfile.streak = 0;
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const diffFromToday = (today.getTime() - uniqueDates[0].getTime()) / (1000 * 60 * 60 * 24);

        if (diffFromToday > 1) {
            userProfile.streak = 0;
            return;
        }

        let currentStreak = 1;
        for (let i = 0; i < uniqueDates.length - 1; i++) {
            const currentDay = uniqueDates[i];
            const previousDay = uniqueDates[i + 1];
            const diff = (currentDay.getTime() - previousDay.getTime()) / (1000 * 60 * 60 * 24);

            if (diff === 1) {
                currentStreak++;
            } else {
                break;
            }
        }
        userProfile.streak = currentStreak;
    }

    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabButtons.length > 0) {
        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));

                button.classList.add('active');
                const targetContentId = 'tab-' + button.dataset.tab;
                const targetContent = document.getElementById(targetContentId);
                if (targetContent) {
                    targetContent.classList.add('active');
                }
            });
        });
    }
});